import React from 'react';
import Flag from 'react-world-flags';
import DSTextField from '../../../design-system/DSTextField';
import DSCircularProgress from '../../../design-system/DSCircularProgress';
import DSAutocomplete from '../../../design-system/DSAutocomplete';
import DSListItem from '../../../design-system/DSListItem';
import DSBox from '../../../design-system/DSBox';
import useCountryDropdown, {
  CountryDropdownProps,
} from '../hooks/useCountryDropdown';

type CountryDropdownComponentProps = CountryDropdownProps & {
  error?: boolean;
  helperText?: string;
};

const CountryDropdown = ({
  initialCountryCode,
  onSelect,
  error,
  helperText,
}: CountryDropdownComponentProps) => {
  const {
    options,
    handleInputChange,
    isLoading,
    spacing,
    selectedCountry,
    handleOptionSelect,
  } = useCountryDropdown({ initialCountryCode, onSelect });

  return (
    <DSAutocomplete
      options={options}
      value={selectedCountry}
      onChange={handleOptionSelect}
      onInputChange={handleInputChange}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => (
        <DSListItem {...props} key={option.code}>
          {option.name}
        </DSListItem>
      )}
      renderInput={(params) => (
        <DSTextField
          {...params}
          placeholder="Select a country..."
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            startAdornment: selectedCountry && (
              <DSBox
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: spacing(1),
                }}
              >
                <DSBox
                  sx={{
                    width: spacing(2.5),
                    height: spacing(2.5),
                    borderRadius: '50%',
                    overflow: 'hidden',
                    flexShrink: 0,
                  }}
                >
                  <Flag
                    code={selectedCountry.code}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                    alt={`${selectedCountry.code} Flag`}
                  />
                </DSBox>
              </DSBox>
            ),
            endAdornment: (
              <>
                {isLoading ? <DSCircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          sx={{
            '.MuiInputBase-root': {
              padding: 0,
            },
          }}
        />
      )}
      sx={{
        minWidth: spacing(18),
        marginLeft: spacing(3),
      }}
    />
  );
};

export default CountryDropdown;
